import { render, staticRenderFns } from "./CollectionType.vue?vue&type=template&id=987b761c&scoped=true&"
import script from "./CollectionType.vue?vue&type=script&lang=js&"
export * from "./CollectionType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "987b761c",
  null
  
)

export default component.exports